/**
 * GDPR/DSGVO Consent Management Constants
 *
 * Diese Konstanten definieren die aktuellen Versionen von Nutzungsbedingungen
 * und Datenschutzrichtlinien sowie deren URLs.
 *
 * WICHTIG: Bei Änderung der Bedingungen müssen die Versionen aktualisiert werden!
 * Format: v{major}.{minor}_{YYYY-MM-DD}
 */

export const GDPR_CONSTANTS = {
  /**
   * Aktuelle Version der Nutzungsbedingungen
   * Format: v{major}.{minor}_{YYYY-MM-DD}
   */
  CURRENT_TERMS_VERSION: 'v1.0_2026-06-20',

  /**
   * Aktuelle Version der Datenschutzerklärung
   * Format: v{major}.{minor}_{YYYY-MM-DD}
   */
  CURRENT_PRIVACY_VERSION: 'v2.0_2026-06-20',

  /**
   * Kombinierte Version (wird an Backend gesendet)
   * Format: Terms-v1.0_2026-06-20_Privacy-v2.0_2026-06-20
   */
  get CURRENT_CONSENT_VERSION(): string {
    return `Terms-${this.CURRENT_TERMS_VERSION}_Privacy-${this.CURRENT_PRIVACY_VERSION}`;
  },

  /**
   * URL zu den Nutzungsbedingungen
   */
  TERMS_URL: 'https://fixplaner.com/nutzungsbedingungen',

  /**
   * URL zur Datenschutzerklärung
   */
  PRIVACY_URL: 'https://fixplaner.com/datenschutz',

  /**
   * URL zum Impressum
   */
  IMPRINT_URL: 'https://fixplaner.com/impressum',
};

/**
 * Interface für Consent-Daten im Frontend
 */
export interface ConsentData {
  termsAccepted: boolean; // Akzeptanz der Nutzungsbedingungen
  privacyPolicyAccepted: boolean; // Kenntnisnahme der Datenschutzinformationen (Art. 13 DSGVO)
  dataProcessingAccepted?: boolean; // LEGACY (seit 2026-06): nicht mehr abgefragt
  marketingConsent: boolean;
  consentVersion: string;
}
